











export default
  name: 'TopFirstPage'

  data: () ->
    showBack: false

  mounted: () ->
    window.addEventListener('scroll', @scroll)

  methods: {
    scroll:() ->
      if window.scrollY > 10
        @showBack = true
  }
